import styled from 'styled-components'
import Media from 'builder/styles/media'

export const ActionContainer = styled.div`
  margin: 8px 0;
  display: flex;
  gap: 8px;

  ${Media.Phone`
    margin: 4px 0;
    flex-direction: column;
  `}
`

export const ActionModalContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 8px;
  margin-top: 32px;
`
